import { IIconProps } from './icon';

interface IIconPeopleProps extends IIconProps {
  pathFill?: string;
}

export const IconPeople = ({
  style = {},
  cy,
  pathFill = 'currentColor',
}: IIconPeopleProps): JSX.Element => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconPeople${cy}`}
    >
      <path
        d="M6.625 9C8.48896 9 10 7.48896 10 5.625C10 3.76104 8.48896 2.25 6.625 2.25C4.76104 2.25 3.25 3.76104 3.25 5.625C3.25 7.48896 4.76104 9 6.625 9Z"
        fill={pathFill}
      />
      <path
        d="M10.4688 10.875C9.14875 10.2047 7.69187 9.9375 6.625 9.9375C4.53531 9.9375 0.25 11.2191 0.25 13.7812V15.75H7.28125V14.9967C7.28125 14.1061 7.65625 13.2131 8.3125 12.4688C8.83609 11.8744 9.56922 11.3227 10.4688 10.875Z"
        fill={pathFill}
      />
      <path
        d="M15.4375 10.5C12.9967 10.5 8.125 12.0075 8.125 15V17.25H22.75V15C22.75 12.0075 17.8783 10.5 15.4375 10.5Z"
        fill={pathFill}
      />
      <path
        d="M15.4375 9C17.7157 9 19.5625 7.15317 19.5625 4.875C19.5625 2.59683 17.7157 0.75 15.4375 0.75C13.1593 0.75 11.3125 2.59683 11.3125 4.875C11.3125 7.15317 13.1593 9 15.4375 9Z"
        fill={pathFill}
      />
    </svg>
  );
};
